import { render, staticRenderFns } from "./ResultsNormalizationPage.vue?vue&type=template&id=b6864e26&"
import script from "./ResultsNormalizationPage.vue?vue&type=script&lang=js&"
export * from "./ResultsNormalizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports